import './draft-form-reset-button.scss';

import { useEffect, useState } from 'react';

import { CustomModal } from '@/components/Shared/Modal/CustomModal';
import { Button } from '@/components/Shared/ui';
import { useAppSelector } from '@/store';

import { getAutoCreditDraftKey } from '../../helpers/helpers';

const DraftFormResetButton = () => {
  const { orderApp } = useAppSelector((state) => state.newOrder);

  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [isUserHasUnsavedData, setIsUserHasUnsavedData] = useState(false);

  const handleDraftClear = () => {
    if (!orderApp) return;
    setIsConfirmModalOpen(false);
    sessionStorage.removeItem(getAutoCreditDraftKey(orderApp.uuid));
    window.location.reload();
  };

  useEffect(() => {
    if (!orderApp) return;
    const unsavedData = sessionStorage.getItem(
      getAutoCreditDraftKey(orderApp.uuid)
    );
    setIsUserHasUnsavedData(!!unsavedData);
    return () => {
      setIsUserHasUnsavedData(false);
    };
  }, [orderApp]);

  if (!isUserHasUnsavedData) return null;
  return (
    <>
      <div className="draft-form-reset-button">
        <span className="draft-form-reset-button__text">
          Некоторые поля заполнены автоматически из ранее сохранённых данных
        </span>
        <Button
          type="button"
          variant="outlined-red"
          size="small"
          onClick={() => setIsConfirmModalOpen(true)}
        >
          Сбросить
        </Button>
      </div>

      <CustomModal
        editClass="draft-form-reset-button__confirm-modal"
        isModalOpen={isConfirmModalOpen}
        handleCancel={() => setIsConfirmModalOpen(false)}
        handleOk={handleDraftClear}
        title="Сбросить сохранённые данные формы?"
        footer={[
          <Button key="back" onClick={() => setIsConfirmModalOpen(false)}>
            Отмена
          </Button>,
          <Button
            key="submit"
            variant="filled-red"
            onClick={() => {
              handleDraftClear();
              setIsConfirmModalOpen(false);
            }}
          >
            Да, сбросить
          </Button>
        ]}
      >
        <span className="draft-form-reset-button__confirm-modal-description">
          Все несохранённые данные будут удалены, а страница — перезагружена.
          Это действие нельзя отменить.
        </span>
      </CustomModal>
    </>
  );
};

export default DraftFormResetButton;
